import { isToday, isYesterday } from "date-fns"

import { formatToddM, formatToHoursAndMinutes } from "utils/datetime-format-utils"

export function getLastDate(date: Date) {
    const timeZoneMinutes = new Date().getTimezoneOffset()
    const dateInUserUtc = new Date(date.getTime() + timeZoneMinutes * 60)
    const isTodayD = isToday(dateInUserUtc)

    if (isTodayD) return formatToHoursAndMinutes(dateInUserUtc)
    else if (isYesterday(dateInUserUtc)) return "Вчера"
    else return formatToddM(dateInUserUtc)
}
